<template>
  
  <v-app id="updm-hsnp">

    <hsnp_navbar_wrapper :hspt="wizardData.hspt"/>

    <v-main>
      <v-stepper v-model="wizardstep">
        <v-stepper-header>
          <v-stepper-step :complete="wizardstep > 1" step="1" :color="wizardstep > 1 ? 'success' : 'primary'">
            Select prices
          </v-stepper-step>
          <v-divider />
          <v-stepper-step :complete="wizardstep > 2" step="2" :color="wizardstep > 2 ? 'success' : 'primary'">
            Configure update
          </v-stepper-step>
          <v-divider />
          <v-stepper-step :complete="wizardstep > 3" step="3" :color="wizardstep > 3 ? 'success' : 'primary'">
            Other parameters
          </v-stepper-step>
          <v-divider />
          <v-stepper-step step="4">
            Process
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <hsnp_wizard_step_01 :hspt_encrid="hspt_encrid" :wizardData="wizardData" :hsnp_selected="hsnp_selected" @updateData="updateData" @showMessage="showMessage"/>
          </v-stepper-content>

          <v-stepper-content step="2">
            <hsnp_wizard_step_02 :pricetype="wizardData.price_type" :wizardData="wizardData" @updateData="updateData"/>
          </v-stepper-content>

          <v-stepper-content step="3">
            <hsnp_wizard_step_03 :wizardData="wizardData" @updateData="updateData"/>
          </v-stepper-content>

          <v-stepper-content step="4">
            <hsnp_wizard_step_04 :wizardData="wizardData" :number_hsnp_selected="hsnp_selected.length" @updateData="updateData" @showMessage="showMessage"/>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>

      <div class="navigation">
        <v-row dense>
          <v-col cols="4">
            <v-btn color="primary" @click="back" v-if="wizardstep > 1" class="mr-2"><v-icon class="mr-2">mdi-arrow-left-thin-circle-outline</v-icon>Back</v-btn>
            <v-btn color="warning" @click="restart" v-if="wizardstep > 3" class="mr-2"><v-icon class="mr-2">mdi-restart-alert</v-icon>Restart</v-btn>
          </v-col>  
          <v-col cols="4" class="text-center">
            <span v-if="wizardData.hspt.user==='dennis' || wizardData.hspt.user==='leon' || wizardData.hspt.user==='mark'">
              <v-btn color="primary" @click="toConsole"><v-icon class="mr-2">mdi-console</v-icon>Console</v-btn>              
            </span>
            <v-btn color="warning" @click="clearWizard" class="ml-2"><v-icon class="mr-2">mdi-close-circle-outline</v-icon>Clear</v-btn>        
          </v-col>  
          <v-col cols="4" align="right">
            <v-btn color="primary" @click="next" :disabled="wizardstep > 3" class="mr-3 right">Continue<v-icon class="ml-2">mdi-arrow-right-thin-circle-outline</v-icon></v-btn>
          </v-col>        
        </v-row>
      </div>
    </v-main>
    <standard_dialog ref="std_dialog" />      
  </v-app>
</template>

<script>

import hsnp_wizard_step_01 from '@/components/huis/hspt/hsnp/hsnp_wizard_step_01.vue';
import hsnp_wizard_step_02 from '@/components/huis/hspt/hsnp/hsnp_wizard_step_02.vue';
import hsnp_wizard_step_03 from '@/components/huis/hspt/hsnp/hsnp_wizard_step_03.vue';
import hsnp_wizard_step_04 from '@/components/huis/hspt/hsnp/hsnp_wizard_step_04.vue';
import standard_dialog from '@/components/ui/standard_dialog.vue';

import hsnp_navbar_wrapper from '@/components/huis/hspt/hsnp/hsnp_navbar_wrapper.vue';

export default {
  props: {
    hspt_encrid: String
  },
  components: {
    hsnp_wizard_step_01,
    hsnp_wizard_step_02,
    hsnp_wizard_step_03,
    hsnp_wizard_step_04,
    standard_dialog,
    hsnp_navbar_wrapper
  },
  created(){
    window.addEventListener("resize", this.resizeEventHandler);
    this.wizardData = this.initWizard();
    this.getContractData();
  },  
  destroyed() {
    window.removeEventListener("resize", this.resizeEventHandler);
  },     
  data() {
    return {
      wizardstep: 1,
      wizardData: {},
      hsnp_selected: []
    }
  }, 
  methods: {
    updateData(data){
      if (data.field==='hsnpFromDate'){
        if(this.wizardData.hsnpFromDate !== data.value && data.value !== null && 
           (this.wizardData.hsnpUntilDate === null || data.value >= this.wizardData.hsnpUntilDate)){
          this.wizardData.hsnpUntilDate = data.value;
        }
      }
      if (data.field==='hsnpUntilDate'){
        if(data.value !== null && this.wizardData.hsnpFromDate !== null && (this.wizardData.hsnpFromDate > data.value)){
          this.wizardData.hsnpFromDate = data.value;
        }
      }      
      if (data.field==='selected_prices'){
        this.hsnp_selected = data.value;
        return;
      }
      this.wizardData[data.field] = data.value;
    },
    showMessage(data){
       data.clear ? this.clearWizard() : false;
       this.showDialog(data.type, data.caption, data.message);
    },
    clearWizard(){
      this.wizardData = this.initWizard();
      this.hsnp_selected = [];
      this.getContractData();
    },
    resizeEventHandler() {
       this.wizardData.wInnerHeight = window.innerHeight;       
    },
    next(){
      this.wizardstep++;      
    },
    back(){
      if(this.wizardstep === 4){
        this.wizardData.new_prices=[];
      }
      this.wizardstep--;
    },
    showDialog(type, caption, message){
      this.$refs.std_dialog.open(type, caption, message);
    },
    restart(){
      this.wizardstep = 1;
      this.clearWizard();
      this.initSelection();
    },
    initSelection(){
      this.hsnp_selected = [];
    },
    initWizard(){
      return {
        hspt:{},
        hsnpFromDate: new Date().toISOString().substring(0, 10), // just the date, not the time
        hsnpUntilDate: null,
        savedDateRanges: [],
        purchase_amount_from: '0',
        purchase_amount_until: '0',        
        sales_amount_from: '0',
        sales_amount_until: '0',        
        toggled_prices:[],
        price_type: null,
        wInnerHeight: window.innerHeight,
        purchase_relative: true,
        purchase_quantity: '0', 
        purchase_old: '0',
        purchase_new: '0',
        purchase_type: '+', 
        purchase_operator: 'P',
        purchase_days: [true,true,true,true,true,true,true,true],
        purchase_minpurchase_auto_update: 0,
        purchase_sales_auto_update: 1,
        purchase_weekprice_auto_update: 0,
        minpurchase_relative: true,
        minpurchase_quantity: '0', 
        minpurchase_old: '0',
        minpurchase_new: '0',
        minpurchase_operator: 'P',
        minpurchase_days: [true,true,true,true,true,true,true,true],        
        margin_relative: true,        
        margin_auto_update: 0,
        margin_minpurchase_auto_update: false,
        margin_weekprice_auto_update: false,
        margin_quantity: '0', 
        margin_old: '0',
        margin_new: '0',
        margin_days: [true,true,true,true,true,true,true,true],        
        sales_relative: true,
        sales_quantity: '0', 
        sales_old: '0',
        sales_new: '0',
        sales_operator: 'P',
        sales_days: [true,true,true,true,true,true,true,true],
        sales_minpurchase_auto_update: 0,
        sales_purchase_auto_update: 2,
        sales_weekprice_auto_update: 0,
        other_arrival_days: [false,false,false,false,false,false,false,false],
        other_arrival_days_remove: [false,false,false,false,false,false,false],
        other_arrival_days_num: ['0','0','0','0','0','0','0'], 
        other_arrival_days_override: false,  
        other_departure_days: [false,false,false,false,false,false,false,false],
        other_departure_days_remove: [false,false,false,false,false,false,false],
        other_departure_days_num: ['0','0','0','0','0','0','0'], 
        other_departure_days_override: false,  
        other_min_nights_days_num: ['0','0','0','0','0','0','0'], 
        other_min_nights_days_remove: [false,false,false,false,false,false,false],
        other_min_nights_days_override: false,
        other_planning_days: [false,false,false,false,false,false,false,false],
        other_planning_days_num: ['0','0','0','0','0','0','0'], 
        other_planning_days_override: false,
        other_cleaning_days_num: ['0','0','0','0','0','0','0'], 
        other_cleaning_days_remove: [false,false,false,false,false,false,false],
        other_cleaning_days_override: false,
        weekprice_relative: true,
        weekprice_quantity: '0', 
        weekprice_old: '0',
        weekprice_new: '0',
        weekprice_operator: 'P',
        weekprice_days: [true,true,true,true,true,true,true,true],        
        new_prices: [],
        error: 0,
        warning: 0,
        updated: 0,
        correct: 0,
        skipClosedDates: true,
        filter: "no_filter",
        useAllExactFromAmountWildcard: false,
      }
    },
    toConsole(){
      this.showDialog('error', 'test dennis', 'geen echte fout gewoon ff checken')
      console.log(this.wizardData);
    },
    getContractData(){
      this.$axios
      .post("ares/json/ares/huis/hspt/hsnp/getSingleHspt.p", {
        header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getSingleHspt"
        },
        getSingleHspt: {
            hspt_encrid: this.hspt_encrid,
        }
      })
      .then(res => {
        if (res.data.error) {
          let message = new Object();
          message.clear = false; // niet aanzetten anders gaat het mis
          message.type = 'error';
          message.caption = 'Time out';
          message.message = res.data.error.message; 
          this.showMessage(message);                            
        }  else { 
          this.wizardData.hspt = res.data.getSingleHspt;
          this.wizardData.hspt.title = res.data.getSingleHspt.price_structure.toUpperCase()==='NIGHT' ? 'Ares - Night prices' : 'Ares - LOS prices';          
          this.wizardData.price_type = res.data.getSingleHspt.contract_type===1 ? 0 : 2; 
        }
      })         
    }        
  }
}
</script>

<style lang="scss" scoped>

.navigation{
  position: fixed;
  bottom: 15px;
  left: 15px;
  right: 15px;  
}
.right{
  right:0;
}
.v-stepper__items {
  position: relative;
  overflow-y: scroll;
  height: calc(100vh - 195px);
}
</style>